#import "./TeamFields.graphql"

query GetTeams($includeArchived: Boolean) {
  teams(includeArchived: $includeArchived) {
    ...TeamFields
  }
}
